const tw = {
  common: {
    smartPhoneOrder: '手機點餐',
    seatNumber: '桌號',
    orderIsNowAvailableWithASmartphone: '現在使用智能手機訂餐的服務也已經開通',
    readTheQrCodeAgainAfterClosingTheApp: '如果您退出了應用程序，請再次讀取二維碼',
    orderWithOtherSmartphones: '從另一部智能手機訂餐',
    youCouldOrderWithOtherSmartphonesByReadingTheQrCodeShownOnThisPhone:
      '如果您用一台智能手機讀取了顯示的二維碼，使用其他智能手機也可訂餐',
    showTheQrCode: '顯示二維碼',
    youCouldOrderWithAMaximumOf6Smartphones: '最多可以使用6台智能手機訂餐',
    close: '關閉',
    howToUse: '使用方法',
    doNotDisplayThisDialogAgain: '此後不再顯示',
    todaysSpecialMenu: '今日推薦',
    cancel: '取消',
    numberBefore: '',
    numberAfter: '號',
    finishedDishes: '投入盤數',
    dishes: '盤',
    call: '服務鈴',
    check: '結帳',
    home: '主畫面',
    search: '搜尋',
    return: '返回',
    pleaseWaitTheEmployeeWillArriveShortly: '店員馬上就會過來。\n請稍等片刻。請停留在此畫面，謝謝',
    cancelTheCall: '取消呼叫',
    orderWithOtherCustomersSmartphone: '同桌就餐的顧客也可以通過智能手機訂餐',
    order: '點餐',
    yes: '是',
    no: '不是',
    end: '結束',
    putIn: '投入完畢',
    staffCalling: '呼叫店員',
    smartphoneOrderSuccess: '手機點餐結束',
    certification: '認證中',
    pleaseWait: '請稍候',
    busyTimes: '待畫面切換需花費一定時間，敬請見諒',
    scanTheQRCodeAgain: '如果畫面沒有切換　請再次掃描QR CODE',
    recommendMenu: '推薦一覽',
    callStaff: '呼叫',
    cancelCall: '取消呼叫',
    yen: '日元',
    twGen: '元',
    cnGen: '元',
    dollar: '{price}美元',
    calorieUnit: 'kcal',
  },
  welcome: {
    smartPhoneOrderDescription: '通過掃描螢幕上的QR CODE,\n即可通過手機點餐',
    availableShopList: '可使用手機點餐的店鋪',
    operationMethod: '操作方法',
    alreadyInstalledApp: '已安裝くら寿司APP的客戶',
    alreadyInstalledAppDescription:
      '通過APP內的「手機點餐」按鈕可以開啟手機照相功能,以讀取平板上的QR CODE',
    notInstalledApp: '尚未安裝くら寿司APP的客戶',
    notInstalledAppDescription: '開啟手機相機,讀取平板上的QR CODE',
  },
  preOrder: {
    'pre-orderConfirm': '確定預訂單',
    pleaseReadTheQrCodeAfterTheGuidance: '帶位後，請讀取QR CODE',
    'thePre-orderingMenuIs10ForMaximum': '預訂商品數量最多10個品項。',
    appointmentNumber: '預約號碼',
    comfirming: '確認中',
    shop: '店',
    receptionNumber: '預約號碼',
    reservationUsherTime: '預定帶位時間',
    numberOfReservations: '預約人數',
    preOrder: '提前點餐',
    preOrderhowToUseDescription: '按下紅色按鈕\n掃QR CODE\n即可點餐',
    soldOutDescription: '缺貨的商品無法點餐',
    preOrderLimitOver: '超過事前點餐上限.\n入座後可以再次點餐',
  },
  sideMenu: {
    settings: '設置',
    menuAppearance: '菜單顯示',
    menuLarge: '大',
    menuSmall: '小',
    languageSettings: '語言設置',
    showTheQrCodeAuthenticationForConnectingWithOtherSmartphones: '顯示子機認證二維碼',
    closeTheOrderScreenWithTheSmartphone: '關閉手機點餐畫面',
    regardingSmartPhoneOrder: '關於手機點餐',
    showAllergenInformation: '顯示過敏源情報',
  },
  orderHistory: {
    orderHistoryOfThisWholeTableWillBeDisplayed: '顯示該餐桌的所有訂餐歷史記錄。',
    orderHistory: '點餐記錄',
    todaysOrderHistory: '今日的訂餐歷史記錄',
    arrived: '已送達',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-prefix': '顯示上次來店時的點餐歷史記錄',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-suffix': '件',
    orderFromSmartphone: '手機點餐內容',
    arriveComplete: '已送達',
    orderPending: '忙線中',
    pastOrderHistory: '歷史紀錄',
    pastOrderHistoryDescription: '※31天內的歷史紀錄若達100件以上,只會顯示最新100件',
  },
  search: {
    searchCandidates: '您是不是想搜尋',
    searchDescription: '輸入關鍵字,相關商品會出現',
    searchResultBefore: '',
    searchResultAfter: '的搜尋結果',
    listening: '聽取中',
  },
  howToUse: {
    howToOrderWithTheSmartphone: '使用智能手機訂餐的操作方法',
    canOrderWithSmartPhone: '可以使用手機點餐',
    sideMenuAlsoCanMakeBikkuraPon: '副餐也可以進行扭蛋遊戲',
    canCompleteOrderBeforeMeal: '可提前在入座前完成點餐',
    preOrderAfterReserved:
      '完成訂位後即可事先手機點餐。\n入座後掃描平板電腦的QR CODE,事先點餐內容會自動送出',
    noLimitForOrder: '同一桌可以使用手機點餐人數沒有限制',
    scanQrAndStart: '掃描平板電腦的QR CODE即可手機點餐',
  },
  order: {
    thankYouForYourOrder: '謝謝你的訂餐',
    theOrderHasBeenReceived: '點餐已確認',
    arrangeOfSpecialAndPopularMenu: '人氣和推薦組合',
    cancelTheCheck: '取消結帳',
    orderCancelConfirmation: '要取消點餐嗎?',
    pleaseWait: '請稍後',
    checkCancelDescription: '若要取消結帳,\n請使用平板電腦進行取消',
    endOrder: '結束手機點餐',
    askEndOrder: '結束手機點餐。仍要繼續嗎?',
    endOrderConfirmation: '要結束手機點餐嗎?',
    endOrderAttention:
      '若無其他的手機正在使用本點餐系統,今日的點餐歷史紀錄及扭蛋紀錄會消失。您仍要結束手機點餐嗎?',
    endSession: '已中斷連線,結束手機點餐即將關閉',
  },
  bikkuraPon: {
    'bikkura-pon': '[ビッくらポン！] 扭蛋遊戲',
    'bikkura-pon-jp': '[ビッくらポン！] 扭蛋遊戲',
    smartPhoneOrderLimited: '手機點餐限定',
    bikkuraPonExplanationBefore: '使用手機點購含此標記之商品,每',
    bikkuraPonExplanationAfter: '即可玩一次扭蛋遊戲(將於餐點送達後累計)',
    startBikkuraPon: '開始扭蛋遊戲',
    howToStartBikkuraPon: '點此以開始扭蛋遊戲',
    pressToStartBikkuraPon: '點選以開始扭蛋遊戲',
    bikkuraPonConfirmation: '是否開始扭蛋遊戲?',
    remainingTimes: '扭蛋遊戲剩餘 {count} 次',
    start: '開始',
    bikkuraPonUnabled: '無法進行扭蛋遊戲',
    drawingFailure: '扭蛋遊戲無法進行\n請確認網路環境以及扭蛋遊戲剩餘次數後重新操作',
    bikkuraPonInProgress: '扭蛋抽獎中',
    bikkuraPonInProgressDescription: '扭蛋抽獎中,請稍候再操作',
    congratulations: '中獎',
    lose: '失敗',
  },
  present: {
    arrivedPresent: '恭喜您獲得くら寿司獎品',
    cannotCancelOperation: '※無法取消操作',
    notReceive: '不領取',
    receive: '領取',
  },
  textInImage: {
    waitingArea: '候位區',
    jackpot: '中獎',
    lose: '失敗',
    numberPlate: '號碼牌',
  },
  error: {
    oparateFromTouchPanel: '請使用桌席的平板電腦重新操作。',
    networkError: '連接失敗',
    failedToProcess: '處理失敗',
    notFound: '您搜尋的頁面不存在',
    notFoundOrRemoved: '您搜尋的頁面不存在,或是已被更改',
    operatingAgainOnTopPage: '請您從主畫面「手機點餐」重新操作',
    backToTop: '返回主畫面',
    limitErrorDescription: '非常抱歉,已超過點餐上限,請稍候再繼續點餐',
    orderStopErrorDescription: '非常抱歉,已超過點餐上限,請稍候再繼續點餐',
    stockoutErrorDescription: '此商品缺貨中,請選擇其他商品',
    orderError: '請稍候再次操作\n若仍無法解決,請向店員尋求協助',
    unableToAuthenticate: '無法認證',
    failureToAuthorization: '認證失敗',
    systemError: '系統錯誤',
    unknownError: '不明錯誤',
    unknownErrorDescription: '發生無法預期的錯誤,APP停止運作了',
    pleaseReload: '抱歉,請您重新加載瀏覽器',
    reload: '重新加載',
  },
  selfcheck: {
    comfirmNumbers: '人數確認',
    singleSeatCheckOut: '僅本桌進行結帳嗎?',
    multiSeatsCheckOut: '若需要和其他桌合併結帳,請選擇"不是"\n將由店員過來結帳',
    dishesConfirm: '確認盤數',
    paymentConfirm: '確認金額',
    sushiPlate: '壽司盤',
    redPlate: '紅盤',
    buckleSeparate: '扣環需分解',
    putThePlateInThrowingSlot: '請將盤子放入投入口',
    accountingConfirmation: '請確認 結帳內容',
    contents: '內容',
    quantity: '數量',
    totalAmount: '總計',
    checkConfirmed: '內容已確認',
    takeNumberPlateToTheCounter: '請帶著桌號牌至櫃台結帳',
    checking: '結帳中',
    waitUntilRedirect: '確認結帳內容後畫面會自動切換',
    howToCancelSelfcheck: '若要取消結帳,\n請使用平板電腦或此手機進行取消',
    checkOutContentHasBeenChanged: '結帳內容有變動',
    pleaseCheckAgain: '請再次確認',
    closeCheckPageConfirmation: '是否結束結帳?',
    abortCheckAndBackToMainConfirmation: '即將結束結帳,返回主畫面\n仍要繼續嗎',
    howToCancelCheckOut: '若要取消結帳,請使用平板電腦進行取消',
    smartphoneOrderFinished: '結束手機點餐',
    staffComingPleaseWait: '正在呼叫店員\n請稍候',
    error: '錯誤',
    failedToLoading: '讀取失敗',
    selfcheckTryAgainApology: '讀取失敗\n即將中斷結帳\n請返回主畫面\n重新操作',
    backToMainMenu: '返回主畫面',
    selfcheckRestartApology:
      '處理失敗,返回主畫面\n若畫面沒有自動切換,請使用平板電腦,點選返回按鈕操作',
    selfcheckWaitMomentApology:
      '結帳失敗\n請稍候再次操作\n若仍無法成功結帳,請您呼叫店員協助操作,或使用平板電腦進行操作',
    calling: '呼叫',
    confirming: '確認中',
    useTouchPanel: '請使用平板電腦,點選返回按鈕操作',
  },
  pageTitle: {
    shopMenu: '主畫面',
    order: '點餐',
    ad: '推薦一覽',
    adOrder: '推薦一覽',
    recommendOrder: '推薦',
    history: '點餐記錄',
    historyOrder: '點餐記錄',
    search: '搜索',
    searchOrder: '搜索',
  },
  siteId: '手機點餐 |くら寿司',
}

export default tw
